<main>
    <app-hero></app-hero>
    <section class="bg-grey">
      <section class="section-block">
          <app-carousel title="Популарни производи" [products]="popularProducts()"></app-carousel>
      </section>
      <section class="section-block">
        <app-carousel title="Распродажба" [products]="productsOnSale()"></app-carousel>
      </section>
    </section>
    <section class="bg-grey">
      <section class="section-block">
        <app-carousel title="Последно посетени производи" [products]="lastVisitedProducts()"></app-carousel>
      </section>
      <section class="section-block">
        <app-carousel title="Најдобри зделки на денот" [products]="bestDealsProducts()"></app-carousel>
      </section>
    </section>

    <!-- <Banner
      title="Новиот Lenovo лаптоп ги руши сите рекорди"
      description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere illo cupiditate in repellat. Quod, obcaecati?"
      backgroundImage="/backgrounds/62.webp"
    />

    <section class="bg-grey">
      <SectionBlock>
        <Carousel title="Последно посетени производи" products={lastVisitedProducts} />
      </SectionBlock>
      <SectionBlock>
        <Carousel title="Најдобри зделки на денот" products={bestDealsProducts} />
      </SectionBlock>
    </section>

    <Banner
      title="Паметни телефони за паметни луѓе"
      description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere illo cupiditate in repellat. Quod, obcaecati?"
      backgroundImage="/backgrounds/63.webp"
    /> -->
    <!-- <section class="bg-grey">
      <PartnersCarousel partners={partners} title="Партнери" />
    </section> -->
</main>